import { Paper, Select } from '../../../../common/Form'
import {
  MatroxD4ApplianceSettings,
  MatroxDecoderFramerateFamily,
  MatroxDecoderGenlockSource,
} from 'common/api/v1/types'

interface Props {
  settings: MatroxD4ApplianceSettings
}

const sourceOptions = Object.values(MatroxDecoderGenlockSource)
const framerateFamilyOptions = Object.values(MatroxDecoderFramerateFamily)

const MatroxD4SettingsComp = (_: Props) => {
  return (
    <Paper title="Matrox D4 Settings">
      <Paper title="Decoder Genlock">
        <Select label="Source" name={`settings.genlock.source`} required options={sourceOptions} />
        <Select
          label="Framerate Family"
          name={`settings.genlock.framerateFamily`}
          required
          options={framerateFamilyOptions}
        />
      </Paper>
    </Paper>
  )
}

export default MatroxD4SettingsComp
